import {types} from './types';

const setGetListLotteryAction = (payload) => {
  return {
    type: types.SET_LIST,
    payload,
  }
}

const setGetViewLotteryAction = (payload) => {
  return {
    type: types.SET_VIEW,
    payload
  }
}

const setGetStatLotteryAction = (payload) => {
  return {
    type: types.SET_STAT,
    payload
  }
}

const setGetPrizeLotteryAction = (payload) => {
  return {
    type: types.SET_PRIZE,
    payload
  }
}

const setGetWinnersLotteryAction = (payload) => {
  return {
    type: types.SET_WINNERS,
    payload
  }
}

export {
  setGetListLotteryAction,
  setGetViewLotteryAction,
  setGetStatLotteryAction,
  setGetPrizeLotteryAction,
  setGetWinnersLotteryAction
}